import { createApolloClient } from 'hubspot-apollo-client';
export const apolloClient = createApolloClient({
  useBatched: true,
  connectToDevTools: true
});